import React, { useEffect } from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react';
import { DatePicker, Form } from 'antd'
import type { Rule } from "antd/es/form"
import WithLabel from '../../ui/WithLabel/WithLabel';
import { AppControlUISchema } from '../form-types';
import { ControlElement, ControlProps as JSFControlProps } from '@jsonforms/core';
import styles from '../styles/JsonForm.module.scss';
import dayjs from 'dayjs';
import { FormIcon } from '../icon';

const DATA_FORMAT = 'YYYY-MM-DD'; // todo
const VIEW_FORMAT = 'DD-MM-YYYY'; // todo

type ControlProps = Omit<JSFControlProps, "uischema"> & {
  data: string
  handleChange(path: string, value: string): void
  path: string
  uischema: AppControlUISchema<unknown> | ControlElement
}

const DateControl: React.FC<ControlProps> = ({
  label,
  data,
  path,
  enabled,
  required,
  uischema,
  handleChange
}) => {
  const { columns = 1, placeholder, icon, extraRules } = uischema.options ?? {};

  const form = Form.useFormInstance();

  form.getFieldsValue();

  const rules: Rule[] = [
    { required, message: `${label} is required` },
    ...(extraRules ?? [])
  ]

  useEffect(() => {
    if (data !== form.getFieldValue(path)) {
      form.setFieldsValue({ [path]: data ? dayjs(data, DATA_FORMAT) : undefined });
    }
  }, [data]);

  return (
    <Form.Item
      name={path}
      rules={rules}
      initialValue={data ? dayjs(data, DATA_FORMAT) : null}
      validateTrigger='onSubmit'
      validateFirst
      style={{
        gridColumn: `span ${columns}`,
      }}
      getValueFromEvent={(value: dayjs.Dayjs) => {
        handleChange(path, value ? value.format(DATA_FORMAT) : undefined);
        return value || null;
      }}
    >
      <WithLabel
        icon={<FormIcon name={icon} size={18} />}
        label={label}
        required={required}
      >
        <DatePicker
          disabled={!enabled}
          placeholder={placeholder}
          className={styles.datePicker}
          format={VIEW_FORMAT}
          getPopupContainer={() => document.getElementById('App') || document.body}
        />
      </WithLabel>
    </Form.Item>
  )
};

export default withJsonFormsControlProps(DateControl as any);
